import {
  SEND_ADHOC_AUTHORIZATION,
  SEND_ADHOC_AUTHORIZATION_SUCCESS,
  SEND_ADHOC_AUTHORIZATION_FAIL
} from "../actions/sendAdhocEmail";
import { handleActions } from "../../utils/redux-utils";

export const initialState = {
  loading: false,
  loadingProspectId: null,
  isEmailSent: false,
  isEmailEnabled: true,
  emailResponse: {}
};

export default handleActions(
  {
    [SEND_ADHOC_AUTHORIZATION]: (state, { payload }) => ({
      ...state,
      loading: true,
      loadingProspectId: payload.prospectId,
      isEmailSent: false,
      isEmailEnabled: true,
      emailResponse: initialState.emailResponse
    }),
    [SEND_ADHOC_AUTHORIZATION_SUCCESS]: (state, { payload }) => ({
      ...state,
      loading: false,
      loadingProspectId: null,
      isEmailSent: true,
      isEmailEnabled: false,
      emailResponse: payload
    }),
    [SEND_ADHOC_AUTHORIZATION_FAIL]: state => ({
      ...state,
      loading: false,
      isEmailSent: false,
      isEmailEnabled: true,
      emailResponse: initialState.emailResponse
    })
  },
  initialState
);
